var config = {
  shadows: {
    10: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 4
      },
      shadowOpacity: 0.05,
      shadowRadius: 20,
      elevation: 1
    },
    11: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 6
      },
      shadowOpacity: 0.15,
      shadowRadius: 16,
      elevation: 1
    },
    12: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: -4
      },
      shadowOpacity: 0.07,
      shadowRadius: 8,
      elevation: 2
    },
    13: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 4
      },
      shadowOpacity: 0.3,
      shadowRadius: 10,
      elevation: 1
    },
    14: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: -2
      },
      shadowOpacity: 0.08,
      shadowRadius: 8,
      elevation: 1
    },
    15: {
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: -5
      },
      shadowOpacity: 0.06,
      shadowRadius: 8,
      elevation: 1
    },
    16: {
      textShadowColor: "#863724",
      textShadowOffset: {
        width: 0,
        height: 0
      },
      textShadowRadius: 20
    },
    17: {
      shadowColor: "#000000",
      shadowOffset: {
        width: 0,
        height: 3
      },
      shadowOpacity: 0.12,
      shadowRadius: 6.05,
      elevation: 4
    }
  }
};
export default config;